import { getDisplayName } from "verdi-common/schemas/commonGetters/getDisplayName";
import { ThirdPartyDevice } from "verdi-common/schemas/thirdPartyDevice/thirdPartyDevice";
import { SensoterraMoistureSensor, ThirdPartyDeviceBase } from "verdi-web-client";
import { DeviceBase } from "verdi-web-client/Models/Devices/DeviceBase";
import { IrrigationDeviceBase } from "verdi-web-client/Models/Devices/IrrigationDeviceBase";
import type { ListDataStreams200Item } from "@/api/orval/generated/schemas";

type ZoneDeviceModel = IrrigationDeviceBase | ThirdPartyDeviceBase | SensoterraMoistureSensor;

/** Ephemeral generator output — id, display name, unitCategory. See ARCHITECTURE.md § Spec Type Flow. */
export interface ResolvedStream {
    id: number;
    unitCategory: string;
    name: string;
}

// Map API streams to ResolvedStream — display name from the zone device when possible,
// otherwise "Stream {id}". unitCategory is passed through for panel grouping.
export function resolveStreams(
    streams: ListDataStreams200Item[],
    devices?: (IrrigationDeviceBase | ThirdPartyDeviceBase | SensoterraMoistureSensor | ThirdPartyDevice)[],
): ResolvedStream[] {
    return streams.map((stream) => {
        let streamName = `Stream ${stream.id}`;

        const deviceId = stream.latestFragment?.device.id;

        if (deviceId != null) {
            const device = Array.isArray(devices)
                ? devices.find((d): d is ZoneDeviceModel => d instanceof DeviceBase && d.id === deviceId)
                : undefined;

            if (device) {
                streamName = getDisplayName(
                    device._lastJSON ?? {
                        node_id: device.id,
                        name: device.name,
                        EnclosureID: "EnclosureID" in device ? device.EnclosureID : undefined,
                    },
                );
            }
        }

        return {
            id: stream.id,
            name: streamName,
            unitCategory: stream.unitCategory,
        };
    });
}
